export enum DeliveryOptions {
  Deliver = 'Deliver',
  Stock = 'Stock on hand',
  None = ''
}